<template>
  <div v-if="value">
    <span class="error--text">{{ displayCountup }}</span>
  </div>
</template>

<script>
export default {
  name: "CountUp",
  props: {
    value: {
      type: String,
      default: () => null,
    },
  },
  data: () => ({
    timer: null,
    displayCountup: null,
  }),
  mounted() {
    if (this.value) {
      console.log(this.value);
      this.timer = setInterval(this.countup, 1000);
    }
  },
  beforeDestroy() {
    if (this.value) {
      clearInterval(this.timer);
    }
  },
  methods: {
    countup() {
      const destinationTime = new Date(this.value);
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - destinationTime.getTime();

      if (timeDifference <= 0) {
        clearInterval(this.timer);
        this.displayCountup = null;
        return;
      }

      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      if (days > 0) {
        this.displayCountup = `${days} ngày`;
      } else if (hours > 0) {
        this.displayCountup = `${hours} giờ`;
      } else if (minutes > 0) {
        this.displayCountup = `${minutes} phút`;
      } else if (seconds > 0) {
        this.displayCountup = `${seconds} giây`;
      } else {
        this.displayCountup = `${hours} giờ ${minutes} phút ${seconds} giây`;
      }
    },
  },
};
</script>

<style scoped></style>
